import React from "react";

export default function WhyFilePigeon() {
  return (
    <div
      style={{
        minHeight: "100vh",
        background: "var(--theme-tint-3)",
        fontFamily: "Arial",
        padding: "32px 20px",
        display: "flex",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          maxWidth: 800,
          width: "100%",
        }}
      >
        {/* Hero Section */}
        <div
          style={{
            background: "#ffffff",
            borderRadius: 16,
            padding: "48px 40px",
            boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
            marginBottom: 24,
            textAlign: "center",
          }}
        >
          <h1
            style={{
              fontSize: 42,
              fontWeight: 800,
              color: "var(--theme-ink)",
              margin: 0,
              marginBottom: 16,
              letterSpacing: -0.5,
            }}
          >
            Why FilePigeon?
          </h1>
          <p
            style={{
              fontSize: 18,
              color: "var(--theme-ink-soft)",
              margin: 0,
              lineHeight: 1.6,
            }}
          >
            Transform hours of manual document organization into minutes of automated efficiency
          </p>
        </div>

        {/* Problem Section */}
        <div
          style={{
            background: "#ffffff",
            borderRadius: 16,
            padding: "32px 40px",
            boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
            marginBottom: 24,
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 12,
              marginBottom: 20,
            }}
          >
            <div
              style={{
                width: 48,
                height: 48,
                borderRadius: "50%",
                background: "#ffe5e5",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 24,
              }}
            >
              ⚠️
            </div>
            <h2
              style={{
                fontSize: 28,
                fontWeight: 700,
                color: "var(--theme-ink)",
                margin: 0,
              }}
            >
              The Problem
            </h2>
          </div>
          <p
            style={{
              fontSize: 16,
              color: "#333",
              lineHeight: 1.7,
              margin: 0,
              marginBottom: 16,
            }}
          >
            Virtual Data Rooms (VDRs) export documents as flat archives with thousands of files.
            Re-uploading these documents to SharePoint or other platforms requires:
          </p>
          <ul
            style={{
              fontSize: 16,
              color: "#333",
              lineHeight: 1.8,
              marginLeft: 20,
              marginBottom: 0,
            }}
          >
            <li><strong>Manual sorting</strong> - Organizing files by document codes (1.1, 1.2.3, etc.)</li>
            <li><strong>Folder recreation</strong> - Rebuilding the hierarchical structure from index files</li>
            <li><strong>Individual uploads</strong> - Uploading files one-by-one or in small batches</li>
            <li><strong>Error-prone matching</strong> - Ensuring files end up in the correct folders</li>
          </ul>
        </div>

        {/* Solution Section */}
        <div
          style={{
            background: "#ffffff",
            borderRadius: 16,
            padding: "32px 40px",
            boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
            marginBottom: 24,
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 12,
              marginBottom: 20,
            }}
          >
            <div
              style={{
                width: 48,
                height: 48,
                borderRadius: "50%",
                background: "var(--theme-tint-16)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 24,
              }}
            >
              ✅
            </div>
            <h2
              style={{
                fontSize: 28,
                fontWeight: 700,
                color: "var(--theme-ink)",
                margin: 0,
              }}
            >
              How FilePigeon Solves It
            </h2>
          </div>
          <p
            style={{
              fontSize: 16,
              color: "#333",
              lineHeight: 1.7,
              margin: 0,
              marginBottom: 16,
            }}
          >
            FilePigeon automates the entire process with intelligent VDR integration:
          </p>
          <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>
            <div style={{ display: "flex", gap: 16 }}>
              <div
                style={{
                  minWidth: 32,
                  height: 32,
                  borderRadius: "50%",
                  background: "var(--theme-accent)",
                  color: "#fff",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontWeight: 700,
                  fontSize: 14,
                }}
              >
                1
              </div>
              <div>
                <h3 style={{ margin: 0, marginBottom: 8, fontSize: 18, color: "var(--theme-ink)" }}>
                  Multi-VDR Support
                </h3>
                <p style={{ margin: 0, fontSize: 15, color: "#555", lineHeight: 1.6 }}>
                  Works with Intralinks, Firmex, Datasite, IdealsVDR, and more. Upload your VDR index file, and FilePigeon automatically parses the folder structure.
                </p>
              </div>
            </div>
            <div style={{ display: "flex", gap: 16 }}>
              <div
                style={{
                  minWidth: 32,
                  height: 32,
                  borderRadius: "50%",
                  background: "var(--theme-accent)",
                  color: "#fff",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontWeight: 700,
                  fontSize: 14,
                }}
              >
                2
              </div>
              <div>
                <h3 style={{ margin: 0, marginBottom: 8, fontSize: 18, color: "var(--theme-ink)" }}>
                  Automatic Folder Creation
                </h3>
                <p style={{ margin: 0, fontSize: 15, color: "#555", lineHeight: 1.6 }}>
                  Recreates the hierarchical structure automatically in SharePoint. No manual folder creation needed.
                </p>
              </div>
            </div>
            <div style={{ display: "flex", gap: 16 }}>
              <div
                style={{
                  minWidth: 32,
                  height: 32,
                  borderRadius: "50%",
                  background: "var(--theme-accent)",
                  color: "#fff",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontWeight: 700,
                  fontSize: 14,
                }}
              >
                3
              </div>
              <div>
                <h3 style={{ margin: 0, marginBottom: 8, fontSize: 18, color: "var(--theme-ink)" }}>
                  Smart Routing
                </h3>
                <p style={{ margin: 0, fontSize: 15, color: "#555", lineHeight: 1.6 }}>
                  Each file is automatically routed to the correct folder based on its document code. Handles different separator types (-, _, space) and validates folder/file names.
                </p>
              </div>
            </div>
            <div style={{ display: "flex", gap: 16 }}>
              <div
                style={{
                  minWidth: 32,
                  height: 32,
                  borderRadius: "50%",
                  background: "var(--theme-accent)",
                  color: "#fff",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontWeight: 700,
                  fontSize: 14,
                }}
              >
                4
              </div>
              <div>
                <h3 style={{ margin: 0, marginBottom: 8, fontSize: 18, color: "var(--theme-ink)" }}>
                  Bulk Upload with ZIP Support
                </h3>
                <p style={{ margin: 0, fontSize: 15, color: "#555", lineHeight: 1.6 }}>
                  Drag and drop hundreds or thousands of files at once. ZIP archives are automatically extracted and processed.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Time Savings Section */}
        <div
          style={{
            background: "linear-gradient(135deg, var(--theme-accent) 0%, var(--theme-ink) 100%)",
            borderRadius: 16,
            padding: "32px 40px",
            boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
            marginBottom: 24,
            color: "#fff",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 12,
              marginBottom: 20,
            }}
          >
            <div
              style={{
                width: 48,
                height: 48,
                borderRadius: "50%",
                background: "rgba(255,255,255,0.2)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 24,
              }}
            >
              ⚡
            </div>
            <h2
              style={{
                fontSize: 28,
                fontWeight: 700,
                margin: 0,
              }}
            >
              Estimated Time Savings
            </h2>
          </div>
          <div style={{ fontSize: 16, lineHeight: 1.7 }}>
            <div style={{ marginBottom: 16 }}>
              <strong style={{ fontSize: 18 }}>Manual Process:</strong>
              <ul style={{ marginLeft: 20, marginTop: 8, marginBottom: 0 }}>
                <li>Small VDR (500 files, 50 folders): <strong>4-6 hours</strong></li>
                <li>Medium VDR (2,000 files, 150 folders): <strong>15-20 hours</strong></li>
                <li>Large VDR (5,000+ files, 300+ folders): <strong>40-60 hours</strong></li>
              </ul>
            </div>
            <div>
              <strong style={{ fontSize: 18 }}>With FilePigeon:</strong>
              <ul style={{ marginLeft: 20, marginTop: 8, marginBottom: 0 }}>
                <li>Small VDR: <strong>5-10 minutes</strong> ⚡</li>
                <li>Medium VDR: <strong>15-25 minutes</strong> ⚡</li>
                <li>Large VDR: <strong>30-45 minutes</strong> ⚡</li>
              </ul>
            </div>
          </div>
          <div
            style={{
              marginTop: 24,
              padding: 20,
              background: "rgba(255,255,255,0.15)",
              borderRadius: 12,
              textAlign: "center",
            }}
          >
            <div style={{ fontSize: 36, fontWeight: 800, marginBottom: 8 }}>
              95%+ Time Savings
            </div>
            <div style={{ fontSize: 16, opacity: 0.9 }}>
              Hours of manual work → Minutes of automated processing
            </div>
          </div>
        </div>

        {/* Contact Section */}
        <div
          style={{
            background: "#ffffff",
            borderRadius: 16,
            padding: "32px 40px",
            boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
            textAlign: "center",
          }}
        >
          <h2
            style={{
              fontSize: 28,
              fontWeight: 700,
              color: "var(--theme-ink)",
              margin: 0,
              marginBottom: 16,
            }}
          >
            Get in Touch
          </h2>
          <p
            style={{
              fontSize: 16,
              color: "#555",
              lineHeight: 1.7,
              margin: 0,
              marginBottom: 24,
            }}
          >
            Have questions or feedback? Need support for a new VDR provider?<br />
            I'd love to hear from you.
          </p>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: 12,
              alignItems: "center",
            }}
          >
            <div style={{ fontSize: 16, color: "var(--theme-ink)" }}>
              <strong>Email:</strong>{" "}
              <a
                href="mailto:[your-email@example.com]"
                style={{
                  color: "var(--theme-accent)",
                  textDecoration: "none",
                  fontWeight: 600,
                }}
              >
                [your-email@example.com]
              </a>
            </div>
            <div style={{ fontSize: 16, color: "var(--theme-ink)" }}>
              <strong>LinkedIn:</strong>{" "}
              <a
                href="https://linkedin.com/in/[your-profile]"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  color: "var(--theme-accent)",
                  textDecoration: "none",
                  fontWeight: 600,
                }}
              >
                [Your Name]
              </a>
            </div>
            <div style={{ fontSize: 16, color: "var(--theme-ink)" }}>
              <strong>GitHub:</strong>{" "}
              <a
                href="https://github.com/[your-username]"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  color: "var(--theme-accent)",
                  textDecoration: "none",
                  fontWeight: 600,
                }}
              >
                @[your-username]
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
